//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    blok: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      open: []
    }
  },
  methods: {
    toggle(i) {
      const index = this.open.indexOf(i);
      if (index === -1) {
        this.open.push(i)
      } else {
        this.open.splice(index, 1)
      }
    }
  }
}
